import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
    set_token(state,token){
      state.token = token;
    }
  },
  actions: {
  },
  modules: {
  }
})
